import { useLocale } from 'next-intl';
import React from 'react';

const Specifications = ({ specification = [] }) => {
  const locale = useLocale();
  if (!specification.length) return null; // Avoid rendering if empty

  return (
    <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
      <table className='w-full rounded-lg bg-gray-100'>
        <tbody>
          {specification?.map((item, idx) => (
            <tr
              key={idx}
              className='border-border grid grid-cols-4 items-center gap-4 border-b last:border-b-0 max-sm:text-xs'
            >
              <td className='col-span-2 px-6 py-3 max-sm:px-[11px] max-sm:py-[13px] sm:col-span-1 md:px-8'>
                {item?.[locale == 'en' ? '1' : '2']?.label}
              </td>
              <td className='col-span-2 px-6 py-3 font-semibold break-words max-sm:px-4 max-sm:py-2 sm:col-span-3 md:px-8'>
                {item?.[locale == 'en' ? '1' : '2']?.value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Specifications;
